<template>
	<div class="h-full flex justify-center">
		<div class="flex flex-col h-full w-full max-w-xl">
			<div class="grow px-3 sm:px-5 my-3 2xl:my-6">
				<div class="h-full flex flex-col justify-center">
					<offer-request />
					<form id="applicant-form">
						<panel :title="$t('eny.applicant')" addclass="mt-4">
							<div class="flex flex-col items-center pt-6">
								<!-- Gender -->
								<validation cssClass="w-full max-w-text">
									<div class='eny-radio-toolbar'>
										<div class="eny-radio">
											<input type="radio" id="radiomale" name="gender" value='1' v-model="request_loc.gender" />
											<label for="radiomale"><span>{{$t('eny.male')}}</span></label>
										</div>
										<div class="eny-radio">
											<input type="radio" id="radiofame" name="gender" value='0' v-model="request_loc.gender" />
											<label for="radiofame"><span>{{$t('eny.female')}}</span></label>
										</div>
									</div>
								</validation>
								<!-- First Name -->
								<validation cssClass="w-full max-w-text">
									<ejs-maskedtextbox id="fist_name" name="first_name" floatLabelType="Auto" :placeholder="$t('eny.firstname')" v-model:value="user_loc.given_name"></ejs-maskedtextbox>
								</validation>
								<!-- Last Name -->
								<validation cssClass="w-full max-w-text">
									<ejs-maskedtextbox id="last_name" name="last_name" floatLabelType="Auto" :placeholder="$t('eny.lastname')" v-model:value="user_loc.family_name"></ejs-maskedtextbox>
								</validation>
								<!-- E-Mail -->
								<validation cssClass="w-full max-w-text">
									<ejs-maskedtextbox id="email" name="email" floatLabelType="Auto" :placeholder="$t('eny.email')" v-model:value="user_loc.email"></ejs-maskedtextbox>
								</validation>
								<!-- Phone -->
								<validation cssClass="w-full max-w-text">
									<ejs-maskedtextbox id="phone" name="phone" floatLabelType="Auto" :placeholder="$t('eny.mobphone') + $t('eny.mobphoneformat')" v-model:value="user_loc.phone"></ejs-maskedtextbox>
								</validation>
								<!-- Product -->
								<validation cssClass="w-full max-w-text">
									<ejs-maskedtextbox id="product" name="product" floatLabelType="Auto" :placeholder="$t('eny.purpose_of_use')" v-model:value="request_loc.product"></ejs-maskedtextbox>
								</validation>
							</div>
						</panel>
					</form>
					<!-- Buttons -->
					<div v-if="allow_navigation" class="w-full px-10 md:px-20 py-3 2xl:pt-6 flex flex-row justify-center gap-2 sm:gap-6">
						<button type="button" class="eny-btn-blue px-8 py-2 text-2xl font-bold" @click="prevStep">{{$t('eny.back')}}</button>
						<button type="button" class="eny-btn-blue px-8 py-2 text-2xl font-bold" @click="nextStep">{{$t('eny.forward')}}</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
import { MaskedTextBoxComponent, FormValidator } from '@syncfusion/ej2-vue-inputs';
import Panel from "../../Base/Panel.vue";
import Validation from "../../Base/Validation.vue";
import useNotification from "../../hooks/useNotification";
import OfferRequest from "./Request.vue";
import { useI18n } from 'vue-i18n'
export default {
	name: "Applicant",
	components: {
		"ejs-maskedtextbox": MaskedTextBoxComponent,
		'panel': Panel,
		'validation': Validation,
		'offer-request': OfferRequest,
	},
	setup() {
		const {showNotification, hideNotification} = useNotification();
		const { locale } = useI18n({ useScope: 'global' })
		return {
			showNotification,
			hideNotification,
			locale,
		}
	},
	data() {
		return {
			formObject: {},
		};
	},
	created() {
		const params=this.$route.params;
		if (params.firm) {
			//if the page was called with firm name in the URL load the firm if the firm exists or redirect to site root
			//url with params: /offer/applicant/firm/:firm/amount/:amount/duration/:duration/insurance/:insurance
			this.initFromUrlParams(params.firm, params.amount, params.duration, params.insurance)
		}
	},
	mounted() {
		const options = {
			rules: {
				gender: { required: [true, this.$t('eny.field_empty')] },
				first_name: { required: [true, this.$t('eny.field_empty')] },
				last_name: { required: [true, this.$t('eny.field_empty')] },
				email: {
					required: [true, this.$t('eny.user_wrong_email_msg')],
					email: [true, this.$t('eny.user_wrong_email_msg')]
				},
				phone: {
					required: [true, this.$t('eny.field_empty')],
					regex: ["^(\\+41|0)(7[5-9])\\d{7}$", this.$t('eny.phone_not_valid_msg')],
				}
			},
			customPlacement: this.showValidationError,
		};
		this.formObject = new FormValidator("#applicant-form", options);
		this.$store.dispatch('customer/update_offer_step', 0);
	},
	methods: {
		...mapMutations('customer', ['UPDATE_AMOUNT', 'UPDATE_DURATION', 'UPDATE_INCL_INSURANCE', 'UPDATE_USER_FIRM']),
		prevStep: function() {
			this.$router.push('/offer/checklist');
		},
		nextStep: function() {
			if (this.formObject.validate()) {
				this.hideNotification();
				const isNewOffer = !this.user.hasOwnProperty('id')
				this.user_loc.locale = this.locale
				this.$store.dispatch('customer/store', {request: this.request_loc, user: this.user_loc});
			}
		},
		showValidationError: function(element, errorElement) {
			element.closest('.validation-group').querySelector('.error-element').appendChild(errorElement);
		},
		castInt: function(value, min, max) {
			value=parseInt(value);
			value=(isNaN(value) || value<min) ? min : value;
			return (value>max) ? max : value;
		},
		initFromUrlParams: function(firm, amount, duration, insurance) {
			this.$store.dispatch('user/loadFirm', firm)
				.then(()=>this.UPDATE_USER_FIRM(this.firm.id))
				//firm not found, redirect user away
				.catch(() => this.$router.push('/'));
			this.UPDATE_AMOUNT(this.castInt(amount, 1000, 250000));
			this.UPDATE_DURATION(this.castInt(duration, 1, 120));
			this.UPDATE_INCL_INSURANCE(this.castInt(insurance, 0, 1));
		},
	},
	computed : {
		...mapGetters('customer', ['request', 'user', 'loading', 'success', 'message']),
		...mapGetters('user', ['firm']),
		request_loc() {
			return this.request;
		},
		user_loc() {
			this.user.phone = this.user.phone ?? '07';
			return this.user;
		},
		allow_navigation: function () {
			return (this.user && this.user.firm_id) || (this.$keycloak && this.$keycloak.authenticated);
		},
		authenticated: function () {
			return this.$keycloak && this.$keycloak.authenticated;
		}
	},
	watch: {
		message(value, oldValue) {
			if (value !== '') {
				this.showNotification(value, this.success ? 'info ': 'error', 5);
			}
		},
		loading(value, oldValue) {
			if (!value && oldValue && this.success) { // loading => not loading && success
				this.$router.push('/offer/privacy_consent');
			}
		},
	}
}
</script>
<style>
</style>
